import { type Meta } from '../types/docs';
import { SKILL_ANALYTICS_SCOPES, SKILL_ANALYTICS_TYPES } from './skillAnalytics';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_COMPOSER_SKILL_INSERT_SOURCES = [
  'actions_menu',
  'slash_menu',
  'slash_send_resolve',
] as const;

export type WorkspaceAgentComposerSkillInsertSource = (typeof WORKSPACE_AGENT_COMPOSER_SKILL_INSERT_SOURCES)[number];

const META: Meta = {
  description: 'User inserts a workspace agent skill moniker into the composer (prompt not sent yet)',
  name: 'agent_composer_skill_added',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The inserted skill id',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Skill surface (organization workspace agent vs canvas)',
      name: 'type',
      required: true,
      type: 'enum',
      values: [...SKILL_ANALYTICS_TYPES],
    },
    {
      description: 'Skill sharing scope',
      name: 'scope',
      required: true,
      type: 'enum',
      values: [...SKILL_ANALYTICS_SCOPES],
    },
    {
      description:
        'How the skill moniker was inserted: actions_menu (picked from the actions menu), slash_menu (picked from the / slash menu), slash_send_resolve (lone /command auto-resolved immediately before send)',
      name: 'insert_source',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_COMPOSER_SKILL_INSERT_SOURCES],
    },
  ],
};

export default META;
